import styled from 'styled-components'
import { Button } from '@dsny/dsny-component-library'
import { BREAKPOINT_QUERIES } from 'styles/breakpoints'

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @media ${BREAKPOINT_QUERIES.tabletUp} {
    gap: 24px;
  }
`

export const CopyBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;

  @media ${BREAKPOINT_QUERIES.tabletUp} {
    gap: 8px;
  }
`

export const ModalHeader = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column-reverse;
  gap: 4px;
  width: 100%;

  @media ${BREAKPOINT_QUERIES.tabletUp} {
    align-items: center;
    flex-direction: row;
    gap: 16px;
  }
`

export const CloseButton = styled.button`
  align-items: center;
  background: transparent;
  border: 0;
  color: ${({ theme }) => theme.colors.neutralW90};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  flex: 0 0 auto;
  height: 24px;
  justify-content: center;
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  padding: 0;
  width: 24px;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.player50};
    outline-offset: 2px;
  }

  svg {
    flex: 0 0 auto;
    height: 14px;
    width: 14px;
  }
`

export const Title = styled.h2`
  color: ${({ theme }) => theme.colors.neutralW90};
  font-family: ${({ theme }) => theme.fonts?.primary || 'Nunito Sans'};
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  margin: 0;
  overflow-wrap: anywhere;
  width: 100%;

  @media ${BREAKPOINT_QUERIES.tabletUp} {
    flex: 1;
    font-size: 20px;
    min-width: 0;
  }
`

export const BodyText = styled.p`
  color: ${({ theme }) => theme.colors.neutralW70};
  font-family: ${({ theme }) => theme.fonts?.primary || 'Nunito Sans'};
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  margin: 0;
  overflow-wrap: anywhere;
  width: 100%;

  @media ${BREAKPOINT_QUERIES.tabletUp} {
    font-size: 14px;
    line-height: 20px;
  }
`

export const ErrorText = styled(BodyText)`
  color: ${({ theme }) => theme.colors.error70};
`

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @media ${BREAKPOINT_QUERIES.tabletUp} {
    flex-direction: row;
    justify-content: flex-end;
  }
`

export const ActionButton = styled(Button)`
  && {
    font-size: 14px;
    height: 36px;
    line-height: 20px;
    min-height: 36px;
    padding: 6px 16px;
    width: 100%;

    @media ${BREAKPOINT_QUERIES.tabletUp} {
      width: auto;
    }
  }
`
